document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('.shuffle-text');

  if (elements.length === 0) {
    console.warn('Aucun élément avec la classe .shuffle-text trouvé.');
    return;
  }

  const observer = new IntersectionObserver((entries, observerInstance) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const el = entry.target;

        // Ne l’anime qu’une fois
        if (!el.classList.contains('shuffled')) {
          $(el).shuffleLetters();
          el.classList.add('shuffled'); // Pour ne pas le refaire si on scrolle à nouveau
        }

        observerInstance.unobserve(el); // Stoppe l’observation après animation
      }
    });
  }, {
    threshold: 0.6 // 60% visible dans la fenêtre pour déclencher
  });

  elements.forEach((el) => {
    observer.observe(el);
  });
});
